export default {
    namespaced: true,

    state: {
        soundsOn: false,
        chatSoundsOn: false,
        soundsPopupShown: false
    },
    mutations: {
        SET_SOUNDS(state, payload) {
            if (payload) {
                localStorage.setItem('mircity24-admin-sounds', 'true');
            } else {
                localStorage.removeItem('mircity24-admin-sounds');
            }
            state.soundsOn = !!payload;
        },
        SET_CHAT_SOUNDS(state, payload) {
            if (payload) {
                localStorage.setItem('mircity24-admin-chat-sounds', 'true');
            } else {
                localStorage.removeItem('mircity24-admin-chat-sounds');
            }
            state.chatSoundsOn = !!payload;
        },
        SET_SOUNDS_POPUP(state, payload) {
            state.soundsPopupShown = payload;
        }
    },
    actions: {
        async fetch({ commit }) {
            commit('SET_SOUNDS', !!localStorage.getItem('mircity24-admin-sounds'));
            commit('SET_CHAT_SOUNDS', !!localStorage.getItem('mircity24-admin-chat-sounds'));
        }
    }
};
